import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CNameConfiguration, CNameConfigurations } from '@models/email/emailDomain';

@Injectable({
  providedIn: 'root'
})
export class EmailInternalService {
  private readonly baseUrl;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.serverBaseUrl;
  }

  getInternalEmailDomainConfig(): Observable<CNameConfigurations> {
    return this.http.get<Response>(this.baseUrl + 'email/domain/internal').pipe(
      map(data => {
        return CNameConfiguration.deserialize({
          data: (data ? ((data as unknown) as Array<string>) : []).map(data2 => CNameConfigurations.deserialize(data2))
        });
      })
    );
  }

  addInternalEmailDomain(domain: string, subdomain: string): Observable<CNameConfiguration> {
    const body = {
      domain,
      subdomain
    };
    return this.http.post(this.baseUrl + 'email/domain/internal', body).pipe(map(data => CNameConfiguration.deserialize(data)));
  }

  verifyInternaEmailDomain(idDomain: number): Observable<CNameConfiguration> {
    const body = {
      domain_id: idDomain
    };
    return this.http.post(this.baseUrl + 'email/domain/internal/verify', body).pipe(map(data => CNameConfiguration.deserialize(data)));
  }
}
